// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1Idnn","topBottomGutter":"Layout_topBottomGutter__BN73M"};